import { render, staticRenderFns } from "./moveCopy.vue?vue&type=template&id=ff30072e&scoped=true"
import script from "./moveCopy.vue?vue&type=script&lang=js"
export * from "./moveCopy.vue?vue&type=script&lang=js"
import style0 from "./moveCopy.vue?vue&type=style&index=0&id=ff30072e&prod&lang=scss"
import style1 from "./moveCopy.vue?vue&type=style&index=1&id=ff30072e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff30072e",
  null
  
)

export default component.exports